import React , {useEffect} from 'react'
import classes from './Onboarding.module.scss'
import toast from 'react-hot-toast'
import { useSelector} from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

const Onboarding = () => {
  const navigate = useNavigate();
  const state = useSelector(state => state.login);
  
  useEffect(() => {
    const dataToken = JSON.parse(localStorage.getItem('data'))
    if (!state.authentication && !dataToken) {
      navigate('/')
      toast("You've been Logged Out", {
        icon: '❗',
      });
    }
  })
  return (
    <div className={classes.Container}>
      <Outlet/>
    </div>
  )
}

export default Onboarding